import React, { useEffect, useState, useRef } from "react";
import {
  create_user,
  getBlock,
  getDistrict,
  getFY,
  getGPbyBlock,
} from "../../api/User";

function CreateNewUser({ token, userDetail }) {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    designation: "",
    aadhar: "",
    pan_no: "",
    mobile: "",
    emergency_mobile: "",
    employee_type: "",
    employee_categories: "",
    Office_address_1: "",
    home_address_1: "",
    Office_address_2: "",
    home_address_2: "",
    Office_pincode: "",
    home_pincode: "",
    office_tehsil: "",
    home_tehsil: "",
    Office_district: "",
    home_district: "",
    Office_state: "",
    home_state: "",
    current_district: "",
    current_block: "",
    current_village: "",
    ppp_id: "",
    created_by: "",
    updated_by: "",
    password: "",
    department: "",
    department_name: "",
    current_division: "",
    role_id: "",
    district_code: "",
    block_code: "",
    village_code: "",
    notification: "",
    unique_id: "",
    ip_address: "",
    is_active: "",
    is_approve: "",
    isdeactivate: "",
    is_login: "",
    remarks_deactivate: "",
  });
  const role = 6;
  const [districtData, setDistrictData] = useState([]);
  const [districtType, setDistrictType] = useState("");
  const [blockData, setBlockData] = useState([]);
  const [blockType, setBlockType] = useState("");
  const [GPData, setGPData] = useState([]);
  const [GPType, setGPType] = useState("");
  const firstName = document.getElementById("firstName");
  const lastName = document.getElementById("lastName");
  const email = document.getElementById("email");
  const designation = document.getElementById("designation");
  const aadhar = document.getElementById("aadhar");
  const pan = document.getElementById("pan");
  const mobile = document.getElementById("mobile");
  const emergency_mobile = document.getElementById("emergency_mobile");
  const employeeType = document.getElementById("employeeType");
  const employeeCategories = document.getElementById("employeeCategories");
  const district = document.getElementById("district");
  const block = document.getElementById("block");
  const village = document.getElementById("village");
  const [edittedEmail, setEdittedEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [editSuccessMessage, setEditSuccessMessage] = useState("");
  const [edittedLName, setEdittedLName] = useState("");
  const [lNameErr, setLNameErr] = useState("");
  const [FNameErr, setFNameErr] = useState("");
  const [desgErr, setDesgErr] = useState("");
  const [aadharErr, setAadharErr] = useState("");
  const [PANErr, setPANErr] = useState("");
  const [phoneErr, setPhoneErr] = useState("");
  const [employeeTypeErr, setEmployeeTypeErr] = useState("");
  const [empCatErr, setEmpCatErr] = useState("");
  const [officeErr, setOfficeErr] = useState("");
  const [homeErr, setHomeErr] = useState("");
  const [offPinErr, setOffPinErr] = useState("");
  const [homPinErr, setHomPinErr] = useState("");

  const [currentDistrictErr, setCurrentDistrictErr] = useState("");
  const [currentBlockErr, setCurrentBlockErr] = useState("");
  const [currentVillageErr, setCurrentVillageErr] = useState("");
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const emailRef = useRef(null);
  const designationRef = useRef(null);
  const adharRef = useRef(null);
  const panRef = useRef(null);
  const mobileRef = useRef(null);
  const empTypeRef = useRef(null);
  const empCategoryRef = useRef(null);
  const OfficeAddressL1Ref = useRef(null);
  const HomeAddressL1Ref = useRef(null);
  const OfficePincodeRef = useRef(null);
  const HomePincodeRef = useRef(null);
  const currentDistrictRef = useRef(null);
  const currentBlockRef = useRef(null);
  const currentVillageRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fyData = await getFY(token);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const fetchDistrictData = async () => {
      try {
        await getDistrict(token, userDetail.role_id, userDetail.user_id)
          .then((res) => {
            setDistrictData(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    fetchDistrictData(token, userDetail?.role_id, userDetail?.user_id);
  }, [token]);

  const handleDistrictChange = async (e) => {
    const { name, value } = e.target;
    if (name == "current_district" && value) {
      district.classList.remove("is-invalid");
    }
    formData.current_district = e.target.value;
    if (value === "") {
      setCurrentDistrictErr("Please Select an option.");
    } else {
      setCurrentDistrictErr("");
    } 
    setDistrictType(e.target.value);
    const data = {
      role: userDetail.role_id,
      id: userDetail.user_id,
      district: e.target.value,
    };

    try {
      await getBlock(token, data)
        .then((res) => {
          setBlockData(res.user);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleBlockChange = async (e) => {
    const { name, value } = e.target;
    if (name == "current_block" && value) {
      block.classList.remove("is-invalid");
    }
    formData.current_block = e.target.value;
    if (value === "") {
      setCurrentBlockErr("Please Select an option.");
    } else {
      setCurrentBlockErr("");
    } 
    setBlockType(e.target.value);
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: districtType,
      block_code: e.target.value,
    };

    try {
      await getGPbyBlock(token, data)
        .then((res) => {
          setGPData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleGPChange = (e) => {
    const { name, value } = e.target;
    if (name == "current_village" && value) {
      village.classList.remove("is-invalid");
    }
    formData.current_village = e.target.value;
    if (value === "") {
      setCurrentVillageErr("Please Select an option.");
    } else {
      setCurrentVillageErr("");
    } 
    setGPType(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const nameInput = document.getElementById('firstName');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.first_name) {
      nameInput.focus();

      setFNameErr("This field is required.");
      firstNameRef.current.focus();
      return;
    }
    if (!formData.last_name) {
      setLNameErr("This field is required.");
      lastNameRef.current.focus();
      return;
    }
    if (!formData.email) {
      setEmailErr("This field is required.");
      emailRef.current.focus();
      return;
    }
    if (!formData.designation) {
      setDesgErr("This field is required.");
      designationRef.current.focus();
      return;
    }
    if (!formData.aadhar) {
      setAadharErr("This field is required.");
      adharRef.current.focus();
      return;
    }
    if (!formData.pan_no) {
      setPANErr("This field is required.");
      panRef.current.focus();
      return;
    }
    if (!formData.mobile) {
      setPhoneErr("This field is required.");
      mobileRef.current.focus();
      return;
    }
    if (!formData.employee_type) {
      setEmployeeTypeErr("This field is required.");
      empTypeRef.current.focus();
      return;
    }
    if (!formData.employee_categories) {
      setEmpCatErr("This field is required.");
      empCategoryRef.current.focus();
      return;
    }
    if (!formData.Office_address_1) {
      setOfficeErr("This field is required.");
      OfficeAddressL1Ref.current.focus();
      return;
    }
    if (!formData.home_address_1) {
      setHomeErr("This field is required.");
      HomeAddressL1Ref.current.focus();
      return;
    }
    if (!formData.Office_pincode) {
      setOffPinErr("This field is required.");
      OfficePincodeRef.current.focus();
      return;
    }
    if (!formData.home_pincode) {
      setHomPinErr("This field is required.");
      HomePincodeRef.current.focus();
      return;
    }
    if (!formData.current_district) {
      setCurrentDistrictErr("Please Select an option.");
      currentDistrictRef.current.focus();
      return;
    }

    if (!formData.current_block) {
      setCurrentBlockErr("Please Select an option.");
      currentBlockRef.current.focus();
      return;
    } 
    if (!formData.current_village) {
      setCurrentVillageErr("Please Select an option.");
      currentVillageRef.current.focus();
      return;
    }
    const formDataObject = new FormData();
    for (const key in formData) {
      formDataObject.append(key, formData[key]);
    }

    try {
      const res = await create_user(token, formData);
      if (res && res.status === 200) {
        console.log("User created successfully:", res.message);
      } else {
        console.error(
          "Failed to create user:",
          res ? res.message : "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  const handleEditEmail = (e) => {
    const { value } = e.target;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/;
    if (value === "" && emailRegex) {
      setEmailErr("This field is required.");
    } else if (emailRegex.test(value)) {
      setFormData({ ...formData, email: value });
      setEmailErr("");
    } else {
      setEmailErr(
        "Only letters, spaces, hyphens, and apostrophes are allowed."
      );
    }
  };

  const handleLastName = (e) => {
    const { value } = e.target;
    const nameRegex = /^[a-zA-Z\s'-]*$/;
    if (value === "" && nameRegex) {
      setLNameErr("This field is required.");
    } else if (nameRegex.test(value)) {
      setFormData({ ...formData, last_name: value });
      setLNameErr("");
    } else {
      setLNameErr(
        "Only letters, spaces, hyphens, and apostrophes are allowed."
      );
    }
  };

  const handleFirstName = (e) => {
    const { value } = e.target;
    const nameRegex = /^[a-zA-Z\s'-]*$/;
    if (value === "" && nameRegex) {
      setFNameErr("This field is required.");
    } else if (nameRegex.test(value)) {
      setFormData({ ...formData, first_name: value });
      setFNameErr("");
    } else {
      setFNameErr(
        "Only letters, spaces, hyphens, and apostrophes are allowed."
      );
    }
  };
  const handleDesignation = (e) => {
    const { value } = e.target;
    if (value === "no_value") {
      setDesgErr("Please Select an option.");
    } else if (value != "no_value") {
      setDesgErr("");
      setFormData({ ...formData, designation: value });
    }
  };
  const handleAadhar = (e) => {
    const { value } = e.target;
    const aadharRegex = /^[0-9]{0,12}$/;
    if (value.length < 12) {
      setAadharErr("Aadhar number must be exactly 12 digits.");
    } else if (aadharRegex.test(value)) {
      setFormData({ ...formData, aadhar: value });
      setAadharErr("");
    } else if (value.length == 12 || aadharRegex) {
      setAadharErr("");
    }
  };
  const handlePAN = (e) => {
    const { value } = e.target;
    const PANRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (value.length === 10 && PANRegex.test(value)) {
      setFormData({ ...formData, pan_no: value });
      setPANErr("");
    } else if (value.length < 10) {
      setPANErr("PAN must be exactly 10 characters.");
    } else if (value.length === 10 && !PANRegex.test(value)) {
      setPANErr("Invalid PAN format.");
    } else if (value.length > 10) {
      setPANErr("PAN must be exactly 10 characters.");
    }
  };

  const handlePhone = (e) => {
    const { value } = e.target;
    const PhoneRegex = /^[6-9]{1}[0-9]{9}$/;

    if (value.length === 10 && PhoneRegex.test(value)) {
      setFormData({ ...formData, mobile: value });
      setPhoneErr("");
    } else if (value.length < 10) {
      setPhoneErr("Phone number must be exactly 10 characters.");
    } else if (value.length === 10 && !PhoneRegex.test(value)) {
      setPhoneErr("Invalid Phone Number.");
    } else if (value.length > 10) {
      setPhoneErr("Phone number must be exactly 10 characters.");
    }
  };

  const handleEmpType = (e) => {
    const { value } = e.target;
    const nameRegex = /^[a-zA-Z\s'-]*$/;
    if (value === "" && nameRegex) {
      setEmployeeTypeErr("This field is required.");
    } else if (nameRegex.test(value)) {
      setFormData({ ...formData, employee_type: value });
      setEmployeeTypeErr("");
    } else {
      setEmployeeTypeErr(
        "Only letters, spaces, hyphens, and apostrophes are allowed."
      );
    }
  };

  const handleEmpCat = (e) => {
    const { value } = e.target;
    if (value === "no_value") {
      setEmpCatErr("Please Select an option.");
    } else if (value != "no_value") {
      setEmpCatErr("");
      setFormData({ ...formData, employee_categories: value });
    }
  };

  const handleOffAdd = (e) => {
    const { value } = e.target;
    const addRegex = /^[0-9a-zA-Z\s'-,]*$/;
    if (value === "" && addRegex) {
      setOfficeErr("This field is required.");
    }
    else if (addRegex.test(value)) {
      setFormData({ ...formData, Office_address_1: value });
      setOfficeErr("");
    } else {
      setOfficeErr(
        "Only letters, spaces, commas, hyphens and apostrophes are allowed."
      );
    }
    
  };

  const handleHomeAdd = (e) => {
    const { value } = e.target;
    const addRegex = /^[0-9a-zA-Z\s'-,]*$/;
    if (value === "" && addRegex) {
      setHomeErr("This field is required.");
    } else if (addRegex.test(value)) {
      setFormData({ ...formData, home_address_1: value });
      setHomeErr("");
    } else {
      setHomeErr(
        "Only letters, spaces, commas, hyphens and apostrophes are allowed."
      );
    }
  };

  const handleOfficePin = (e) => {
    const { value } = e.target;
    const offPinRegex = /^[0-9]{6}$/;
    if (value === "" && offPinRegex) {
      setOffPinErr("This field is required.");
    } else if (offPinRegex.test(value)) {
      setFormData({ ...formData, Office_pincode: value });
      setOffPinErr("");
    } else {
      setOffPinErr(
        "Only numbers are allowed."
      );
    }
  };

  const handleHomePin = (e) => {
    const { value } = e.target;
    const offPinRegex = /^[0-9]{6}$/;
    if (value === "" && offPinRegex) {
      setHomPinErr("This field is required.");
    } else if (offPinRegex.test(value)) {
      setFormData({ ...formData, home_pincode: value });
      setHomPinErr("");
    } else {
      setHomPinErr(
        "Only numbers are allowed."
      );
    }
  };

  return (
    <>
      <div className="container-fluid col px-2 px-md-4">
        <h5
          className="my-3 px-4 col-12 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "#0d6efd",
            textAlign: "center",
            border: "2px ",
            borderRadius: "10px",
            color: "white",
            padding: "10px",
          }}
        >
          Basic Information
        </h5>
        <form className="filter" id="myform">
          <div className="col align-items-center">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-3 mt-2 d-flex align-items-center">
                  <label className="form-label align-items-center">
                    First Name {<span style={{ color: "red" }}>*</span>}
                  </label>
                </div>
                <div className="col-md-3">
                  <input
                    type="text"
                    name="first_name"
                    defaultValue={formData.first_name}
                    onChange={handleFirstName}
                    id="firstName"
                    ref={firstNameRef}
                    className={`form-control ${FNameErr ? "is-invalid" : ""}`}
                    required
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "10px",
                      marginTop: "0.3rem",
                      display: FNameErr ? "block" : "none",
                    }}
                  >
                    {FNameErr}
                  </p>
                </div>
                <div className="col-md-3 mt-2 d-flex align-items-center">
                  <label className="form-label">Last Name {<span style={{ color: "red" }}>*</span>}</label>
                </div>
                <div className="col-md-3">
                  <input
                    type="text"
                    name="last_name"
                    id="lastName"
                    ref={lastNameRef}
                    defaultValue={formData.last_name}
                    onChange={handleLastName}
                    className={`form-control ${lNameErr ? "is-invalid" : ""}`}

                  />
                  
                  <p
                    style={{
                      color: "red",
                      fontSize: "10px",
                      marginTop: "0.3rem",
                      display: lNameErr ? "block" : "none",
                    }}
                  >
                    {lNameErr}
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-4 col-md-12">
              <div className="row">
                <div className="col-md-3 mt-2 d-flex align-items-center">
                  <label className="form-label">Email {<span style={{ color: "red" }}>*</span>}</label>
                </div>
                <div className="col-md-3">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    ref={emailRef}
                    className={`form-control ${emailErr != "" ? "is-invalid" : ""
                      }`}
                    defaultValue={formData.email}
                    onChange={handleEditEmail}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "10px",
                      marginTop: "0.3rem",
                      display: `${emailErr != "" ? "block" : "none"
                        }`,
                    }}
                  >
                    {emailErr}
                  </p>
                </div>
                <div className="col-md-3 mt-2 d-flex align-items-center">
                  <label className="form-label">Designation {<span style={{ color: "red" }}>*</span>}</label>
                </div>
                <div className="col-md-3">
                  <select
                    name="designation"
                    id="designation"
                    ref={designationRef}
                    defaultValue={formData.designation}
                    onChange={handleDesignation}
                    className={`common-input form-select ${desgErr ? "is-invalid" : ""
                      }`}
                    required
                  >
                    <option value="no_value">Select Designation</option>
                    <option value="Admin_checker">Admin-Checker</option>
                    <option value="Admin_maker">Admin-Maker</option>
                  </select>
                  <p
                    style={{
                      color: "red",
                      fontSize: "10px",
                      marginTop: "0.3rem",
                      display: `${desgErr ? "block" : "none"}`,
                    }}
                  >
                    Invalid Input
                  </p>
                </div>
              </div>

              <div className="mt-4 col-md-12">
                <div className="row">
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Aadhar Number {<span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="aadhar"
                      id="aadhar"
                      ref={adharRef}
                      minLength={12}
                      maxLength={12}
                      className={`form-control ${aadharErr ? "is-invalid" : ""
                        }`}
                      defaultValue={formData.aadhar}
                      onChange={handleAadhar}
                    />

                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${aadharErr ? "block" : "none"}`,
                      }}
                    >
                      {aadharErr}
                    </p>
                  </div>
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">PAN Number {<span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="pan_no"
                      id="pan"
                      ref={panRef}
                      defaultValue={formData.pan_no}
                      minLength={10}
                      maxLength={10}
                      className={`form-control ${PANErr ? "is-invalid" : ""}`}
                      onChange={handlePAN}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${PANErr ? "block" : "none"}`,
                      }}
                    >
                      {PANErr}
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-4 col-md-12">
                <div className="row">
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Personal Mobile Number {<span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="mobile"
                      id="mobile"
                      ref={mobileRef}
                      minLength={10}
                      maxLength={10}
                      className={`form-control ${phoneErr ? "is-invalid" : ""}`}
                      defaultValue={formData.mobile}
                      onChange={handlePhone}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${phoneErr ? "block" : "none"}`,
                      }}
                    >
                      {phoneErr}
                    </p>
                  </div>
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">
                      Emergency Mobile Number
                    </label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      id="emergency_mobile"
                      name="emergency_mobile"
                      maxLength={10}
                      className="form-control"
                      value={formData.emergency_mobile}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-4 col-md-12">
                <div className="row">
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Employee Type {<span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="employee_type"
                      className={`form-control ${employeeTypeErr ? "is-invalid" : ""}`}
                      id="employeeType"
                      ref={empTypeRef}
                      defaultValue={formData.employee_type}
                      onChange={handleEmpType}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${employeeTypeErr ? "block" : "none"}`,
                      }}
                    >
                      {employeeTypeErr}
                    </p>
                  </div>
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Employee Categories {<span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <select
                      name="employee_categories"
                      className={`common-input form-select ${empCatErr ? "is-invalid" : ""
                        }`}
                      defaultValue={formData.employee_categories}
                      onChange={handleEmpCat}
                      id="employeeCategories"
                      ref={empCategoryRef}

                    >
                      <option value="no_value">Select Categories</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                    </select>
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${empCatErr ? "block" : "none"}`,
                      }}
                    >{empCatErr}</p>
                  </div>
                </div>
              </div>
              <h5
                className="my-3 px-4 col-12 d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "#0d6efd",
                  textAlign: "center",
                  border: "2px ",
                  borderRadius: "10px",
                  color: "white",
                  padding: "10px",
                }}
              >
                Address Details
              </h5>
              <div className="mt-4 col-md-12">
                <div className="row">
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Office Address Line-1 {<span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="Office_address_1"
                      className={`form-control ${officeErr ? "is-invalid" : ""}`}
                      ref={OfficeAddressL1Ref}
                      defaultValue={formData.Office_address_1}
                      onChange={handleOffAdd}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${officeErr ? "block" : "none"}`,
                      }}
                    >{officeErr}</p>
                  </div>
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Home Address Line-1 {<span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="home_address_1"
                      className={`form-control ${homeErr ? "is-invalid" : ""}`}
                      defaultValue={formData.home_address_1}
                      ref={HomeAddressL1Ref}
                      onChange={handleHomeAdd}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${homeErr ? "block" : "none"}`,
                      }}
                    >{homeErr}</p>
                  </div>
                </div>
              </div>
              <div className="mt-4 col-md-12">
                <div className="row">
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Office Address Line-2</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="Office_address_2"
                      className="form-control"
                      value={formData.Office_address_2}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Home Address Line-2</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="home_address_2"
                      className="form-control"
                      value={formData.home_address_2}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-4 col-md-12">
                <div className="row">
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Office Pincode {<span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="Office_pincode"
                      minLength={6}
                      maxLength={6}
                      className={`form-control ${offPinErr ? "is-invalid" : ""}`}
                      ref={OfficePincodeRef}
                      defaultValue={formData.Office_pincode}
                      onChange={handleOfficePin}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${offPinErr ? "block" : "none"}`,
                      }}
                    >{offPinErr}</p>
                  </div>
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Home Pincode {<span style={{ color: "red" }}>*</span>}</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="home_pincode"
                      minLength={6}
                      maxLength={6}
                      className={`form-control ${homPinErr ? "is-invalid" : ""}`}
                      ref={HomePincodeRef}
                      defaultValue={formData.home_pincode}
                      onChange={handleHomePin}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${homPinErr ? "block" : "none"}`,
                      }}
                    >{homPinErr}</p>
                  </div>
                </div>
              </div>
              <div className="mt-4 col-md-12">
                <div className="row">
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Office Tehsil</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="office_tehsil"
                      className="form-control"
                      value={formData.office_tehsil}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Home Tehsil</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="home_tehsil"
                      className="form-control"
                      value={formData.home_tehsil}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-4 col-md-12">
                <div className="row">
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Office District</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="Office_district"
                      className="form-control"
                      value={formData.Office_district}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3 mt-2 align-items-center">
                    <label className="form-label">Home District</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="home_district"
                      className="form-control"
                      value={formData.home_district}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-4 col-md-12">
                <div className="row">
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Office State</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="Office_state"
                      className="form-control"
                      value={formData.Office_state}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-3 mt-2 d-flex align-items-center">
                    <label className="form-label">Home State</label>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="home_state"
                      className="form-control"
                      value={formData.home_state}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <h5
                className="my-3 px-4 col-12 d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "#0d6efd",
                  textAlign: "center",
                  border: "2px ",
                  borderRadius: "10px",
                  color: "white",
                  padding: "10px",
                }}
              >
                Map Master Data
              </h5>
              <div className="mt-4 mb-2">
                <div className="d-flex justify-content-between col-md-10 offset-md-1">
                  <div className style={{ width: "30%" }}>
                    <label className="form-label mt-2 ps-0">
                      Current District {<span style={{ color: "red" }}>*</span>}
                    </label>
                    <select
                      id="district"
                      name="current_district"                      
                      className={`common-input form-select ${currentDistrictErr ? "is-invalid" : ""}`}
                      ref={currentDistrictRef}
                      onChange={handleDistrictChange}
                    >
                      <option value="">Select District</option>
                      {districtData?.map((district, index) => (
                        <option key={index} value={district.district_code}>
                          {district.district_name}
                        </option>
                      ))}
                    </select>
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${currentDistrictErr ? "block" : "none"}`,
                      }}
                    >{currentDistrictErr}</p>
                  </div>

                  <div className style={{ width: "30%" }}>
                    <label className="form-label mt-2 ps-0">
                      Current Block {<span style={{ color: "red" }}>*</span>}
                    </label>

                    <select
                      name="current_block"
                      id="block"
                      value={blockType}
                      onChange={handleBlockChange}
                      className={`common-input form-select ${currentBlockErr ? "is-invalid" : ""}`}
                      ref={currentBlockRef}
                    >
                      <option value="">Select Block</option>
                      {blockData?.map((block, index) => (
                        <option key={index} value={block.block_code}>
                          {block.block_name}
                        </option>
                      ))}
                    </select>
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${currentBlockErr ? "block" : "none"}`,
                      }}
                    >{currentBlockErr}</p>
                  </div>

                  <div className style={{ width: "30%" }}>
                    <label className="form-label mt-2 ps-0">
                      Current Gram Panchayat {<span style={{ color: "red" }}>*</span>}
                    </label>
                    <select
                      name="current_village"
                      id="village"
                      onChange={handleGPChange}
                      className={`common-input form-select ${currentVillageErr ? "is-invalid" : ""}`}
                      ref={currentVillageRef}
                    >
                      <option value="">Select Gram Panchayat</option>
                      {GPData?.map((gp, index) => (
                        <option key={index} value={gp.VillageId}>
                          {gp.VillageName}
                        </option>
                      ))}
                    </select>
                    <p
                      style={{
                        color: "red",
                        fontSize: "10px",
                        marginTop: "0.3rem",
                        display: `${currentVillageErr ? "block" : "none"}`,
                      }}
                    >{currentVillageErr}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row col-12 mt-5 d-flex mx-1 mb-5 justify-content-center">
            <button
              type="submit"
              onClick={handleSubmit}
              className="btn me-2 col-md-2"
            >
              Save
            </button>
            <button type="reset" className="btn me-2 col-md-2">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default CreateNewUser;
